<template>
  <!-- request Scu Modal -->
  <div
    class="modal fade"
    id="requestScuModal"
    tabindex="-1"
    aria-labelledby="downloadScuLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="requestScuModalLabel">
            Download Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div  class="modal-body">
          Do you want request a new  System Configuration Update(SCU)?
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-success"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="requestScu"
          >
            Download
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDownloadStore } from "@/stores/download";
import { ref, watch } from "vue";

const downloadStore = useDownloadStore();

const requestScu = async () => {
  await downloadStore.requestSCU();
 
};
</script>
